export function loadAmbassadorWixEventsWebHttp() {
	return import('@wix/ambassador-wix-events-web/http' /* webpackChunkName: "wixEventsWeb" */)
}

export function loadAmbassadorEventsV2RsvpHttp(): Promise<typeof import('@wix/ambassador-events-v2-rsvp/http')> {
	return import('@wix/ambassador-events-v2-rsvp/http' /* webpackChunkName: "wixEventsRsvp" */)
}
